import { useQuery } from "react-query";
import { axiosAuth } from "./axiosConfig";

export const useMapCustomerSamples = (
  periodStart,
  periodEnd,
  locations,
  selectedCustomer
) => {
  const locationIds = locations
    ? locations.map((location) => location.locationId)
    : [];
  return useQuery(
    [
      "map-customer-samples",
      periodStart,
      periodEnd,
      locationIds,
      selectedCustomer,
    ],
    async () => {
      const { data } = await axiosAuth.get("/map-samples/map-customer-samples", {
        params: { periodStart, periodEnd, locationIds, selectedCustomer },
      });
      if (!data) {
        throw new Error("No data found for the specified period.");
      }
      return data;
    },
    {
      retry: false,
      enabled: !!periodStart && !!periodEnd,
    }
  );
};
